import useActions from 'utils/useActions';

import actions from './actions';

export default function useSweetAlert(deps) {
	return useActions(actions, deps);
}
